export default {
  decisionMakerAlias: {
    type: 'string',
    required: true,
  },
};
